<template>
  <div class="flex flex-nowrap">
    <router-link
      v-if="catalogs?.show_page"
      :to="getRouterConfig({ name: 'Projects' })"
      :inert="$route.name === 'Projects'"
      :active-class="`${itemActiveClass} router-link-active`"
      :class="`${itemClass} group`"
      @mouseup.native="pageChanged"
    >
      <lucide-icon
        icon="LayoutList"
        size="16"
        :class="`group-not-[.router-link-active]:text-primary me-2`"
      />
      <span>{{ $t('routes.Projects') }}</span>
    </router-link>
    <!-- :inert="$route.name.startsWith('Interactive')" -->
    <router-link
      v-if="interactiveSettings?.enabled"
      :to="
        getRouterConfig({
          name: 'Interactive',
          params: {
            frameId: interactiveSettings?.default_frame_id,
            interactiveId: interactiveSettings?.default_id,
          },
        })
      "
      :class="{
        [`${itemClass} group`]: true,
        [`${itemActiveClass} router-link-active`]:
          $route.name.startsWith('Interactive'),
      }"
      @click.native="$emit('pageChanged')"
    >
      <lucide-icon
        icon="Interactive"
        size="16"
        :class="`group-not-[.router-link-active]:text-primary me-2`"
      />
      <span>{{
        $t(`routes.Interactive-${interactiveSettings?.translate}`)
      }}</span>
    </router-link>

    <router-link
      v-if="premisesSettings?.enabled"
      :to="getRouterConfig({ name: 'Premises' })"
      :inert="$route.name.startsWith('Premises')"
      :active-class="`${itemActiveClass} router-link-active`"
      :class="`${itemClass} group`"
      @mouseup.native="pageChanged"
    >
      <lucide-icon
        icon="PremisesLayout"
        size="15"
        :class="`group-not-[.router-link-active]:text-primary me-2`"
      />

      <span>{{ $t('routes.Premises') }}</span>
    </router-link>

    <router-link
      v-if="chessSettings?.common.enabled || chessSettings?.plus.enabled"
      :to="getRouterConfig(chessRoute)"
      :class="`${itemClass} group ${
        $route.name.startsWith('Chess')
          ? itemActiveClass + ' router-link-active'
          : ''
      }`"
      :inert="$route.name.startsWith('Chess')"
      @mouseup.native="pageChanged"
    >
      <lucide-icon
        icon="Grid2x2Plus"
        size="16"
        :class="`group-not-[.router-link-active]:text-primary me-2`"
      />
      <span>{{ $t('routes.Chess') }}</span>
    </router-link>

    <router-link
      v-if="infoSettings?.enabled"
      :to="getRouterConfig({ name: 'Info' })"
      :inert="$route.name == 'Info'"
      :active-class="`${itemActiveClass} router-link-active`"
      :class="`${itemClass} group`"
      @mouseup.native="pageChanged"
    >
      <lucide-icon
        icon="FileText"
        size="16"
        :class="`group-not-[.router-link-active]:text-primary me-2`"
      />
      <span>{{ $t('routes.About') }}</span>
    </router-link>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'NavigationMenu',
  components: {},
  computed: {
    ...mapGetters([
      'catalogSettings',
      'chessSettings',
      'infoSettings',
      'project',
      'interactiveSettings',
      'premisesSettings',
      'catalogs',

      // "main_page",
      // "interactiveTranslate",
      // "projects",
      'estates',
    ]),

    chessRoute() {
      let name = 'ChessPlus';
      let params = {};
      if (!this.chessSettings?.plus.enabled) {
        name = 'Chess';
      }
      if (this.project?.type != 2 && this.estates.length > 1) {
        name += 'WithEstate';
        params.estateId = this.estates[0].id;
      }
      return {
        name: name,
        params: params,
      };
    },
  },
  props: {
    itemClass: {
      type: String,
      default: '',
    },
    itemActiveClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    ...mapActions(['LOAD_START']),

    pageChanged() {
      this.LOAD_START('navigate');
      this.$emit('pageChanged');
    },

    clickedChess() {
      // TODO:
      if (this.catalogSettings?.type != 'App\\Models\\ProjectGroup') {
        // console.log('!= App\\\\Models\\\\ProjectGroup\'')
        this.navigate({
          name: 'ChessPlusWithEstate',
          params: { estateId: this.estates[0].id },
        });
        return;
      }
      if (this.catalogSettings?.show_projects == true) {
        // this.showProjects = true;
        // this.projectsOpenChess = true;
      }
    },

    navigate(params) {
      if (!this.$route.name.startsWith(params.name)) {
      }

      this.routerPush(params);
    },
  },
};
</script>
<style scoped lang="scss"></style>
